import { MapContainer, Marker, TileLayer, Tooltip, ZoomControl } from 'react-leaflet';
import TourTags from './tour-tags/tour-tags.component';
import './map.styles.css';
import MarkerClusterGroup from '@changey/react-leaflet-markercluster';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import { useTours } from '../../services/hooks/useTours';
import { useToursContext } from '../../contexts/tour-context';
import tourPinColorHandler from '../../services/tourPinColorHandler';
import { useState } from 'react';
import createIconForCluster from '../../services/createIconForCluster';
import TourSearch from './tour-search/tour-search.component';

export default function MapComponent() {
    const { clickedTourId, clickedTagValue, mapHeight, onTourClickedHandler } = useToursContext();
    const [map, setMap] = useState()
    const [searchParams, setSearchParams] = useState();

    const { areToursFetching, mapTours } = useTours(clickedTagValue, map);
    const matches = useMediaQuery('(min-width:600px)');
    const matches670 = useMediaQuery('(max-width:670px)');
    const matches720 = useMediaQuery('(max-width:720px)');
    const matches1150 = useMediaQuery('(max-width:1150px)');
    const matches1365 = useMediaQuery('(max-width:1365px)');
    const siteHostName = window.location.hostname === 'winetour-northeast.bg' || window.location.hostname === 'winetour-southwest.bg'
    // useEffect(() => showRandomTour(areToursFetchedAfterMount, mapTours), [locationMarkersBounds])

    return (
        <MapContainer id={'map'}
            minZoom={3} maxZoom={18} zoom={8}
            zoomControl={false}
            dragging={true}
            attributionControl={true}
            worldCopyJump={true}
            scrollWheelZoom={false}
            center={[43.528173843405106, 26.999]}
            style={{ height: matches ? mapHeight : '100vh', borderRadius: '8px' }}
            whenReady={(e) => e && setMap(e.target)}
        >
            <ZoomControl position='bottomright' />
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {areToursFetching ?
                <Box position={'absolute'} sx={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 400 }} >
                    <CircularProgress size={60} />
                </Box>
                :
                // <MarkerClusterGroup eventHandlers={{ animationend: (e) => createIconForCluster(e.target, clickedTourId, mapTours) }} removeOutsideVisibleBounds={true} maxClusterRadius={5} showCoverageOnHover={false}>
                mapTours?.map(tour =>
                    <Marker
                        key={tour.id}
                        position={[tour.lat, tour.lng]}
                        icon={tourPinColorHandler(tour, clickedTourId)}
                        eventHandlers={{
                            click: () => {
                                onTourClickedHandler(tour.id)
                            },
                        }}
                        riseOnHover={true}
                    >
                        <Tooltip offset={[12, -25]}>{tour?.title}</Tooltip>
                    </Marker>
                )
                // </MarkerClusterGroup>
            }

            {/* Tags on the map for different types of places */}
            <TourTags searchParams={searchParams} setSearchParams={setSearchParams} />

            {/* Tour search component */}
            {matches &&
                <Box sx={{
                    flexWrap: 'wrap', display: 'flex', justifyContent: 'flex-start', position: 'absolute',
                    top: siteHostName
                        ? { lg: matches1365 ? 50 : 5, md: matches1150 ? 85 : 50, sm: matches720 ? 125 : 85, xs: 125 }
                        : { lg: 5, md: 50, xs: matches670 ? 125 : 85 },
                    right: siteHostName
                        ? { md: matches1365 ? 'unset' : 10, xs: 'unset' }
                        : { lg: 10, md: 'unset', xs: 'unset' },
                    left: siteHostName
                        ? { md: matches1365 ? 8 : 'unset', sm: 8, xs: 50, }
                        : { xs: 50, md: 8, sm: 8, lg: 'unset' },
                    zIndex: 400,
                }}>
                    <TourSearch searchParams={searchParams} setSearchParams={setSearchParams} />
                </Box>
            }

        </MapContainer>
    )
}